import type { PERMISSIONS } from './permissions.catalog';

/** All supported permission keys defined in the permissions catalog. */
export type KnownPermissionKey = keyof typeof PERMISSIONS;
export type PermissionKey = KnownPermissionKey | (string & {});

/** The permission scope determines whether org, project, or card context is required. */
export type PermissionScope = 'org' | 'project' | 'card';

/** Role values that exist at the organization level. */
export type OrgRole = 'BillingOwner' | 'Owner' | 'Admin'| 'Member' | 'Viewer';
/** Role values that exist at the project level. */
export type ProjectRole = 'BillingOwner' | 'Owner' | 'Admin' | 'Member' | 'Viewer';
/** Role values that exist at the card level. */
export type CardRole = 'BillingOwner' | 'Owner' | 'Admin' | 'Member' | 'Viewer';

/** Describes each permission's scope, default allowed roles, and optional documentation note. */
export type PermissionDefinition =
  | {
      scope: 'org';
      defaultAllowedRoles: readonly OrgRole[];
      description?: string;
    }
  | {
      scope: 'project';
      defaultAllowedRoles: readonly ProjectRole[];
      description?: string;
    }
  | {
      scope: 'card';
      defaultAllowedRoles: readonly CardRole[];
      description?: string;
    };

/** Ranked ordering for each role so comparisons become numeric. */
export const ORG_ROLE_RANK: Record<OrgRole, number> = {
  BillingOwner: 4,
  Owner: 3,
  Admin: 2,
  Member: 1,
  Viewer: 0
};

/** Ranked ordering for each project-level role. */
export const PROJECT_ROLE_RANK: Record<ProjectRole, number> = {
  BillingOwner: 4,
  Owner: 3,
  Admin: 2,
  Member: 1,
  Viewer: 0
};

/** Ranked ordering for each card-level role. */
export const CARD_ROLE_RANK: Record<CardRole, number> = {
  BillingOwner: 4,
  Owner: 3 ,
  Admin: 2,
  Member: 1,
  Viewer: 0
};
